"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Singleton_1 = require("./Models/Singleton");
exports.Singleton = Singleton_1.Singleton;
//# sourceMappingURL=Export.js.map